import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=c651b532&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=c651b532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c651b532",
  null
  
)

export default component.exports